import { logger as LOG } from '@garnish/logger';

export const mixpanelLogger = LOG.extend('Mixpanel');
